<div class="pt-16 lg:pt-2">
  <ul class="menu w-full px-4 pb-0" [ngClass]="pt">
    <!-- Separator -->
    <!--  <li></li>-->

    <!-- Process only root items -->
    @for ( item of getRootItems(); let i = $index; track item["Nav-Item-Text"]
    || item["Category-Text"] || $index ) {
    <!-- Separator -->
    @if (isSeparator(item)) {
    <li></li>
    }

    <!-- Category (collapsible section) -->
    @if (isCategory(item)) {
    <li>
      <details
        [id]="getDisclosureId(item['Category-Text'])"
        [attr.open]="
              isRouteActive(item['Category-Text'] || undefined) ? '' : null
            "
      >
        <summary class="group">
          @if (isFontAwesomeIcon(item["Category-Icon"])) {
          <i class="fab fa-spotify"></i>
          } @else {
          <svg-icon
            [src]="getSvgPath(item['Category-Icon']!)"
            [svgClass]="
                    getSvgIconColorClass(item['Category-Icon-Color-Class']!)
                  "
          ></svg-icon>
          } {{ item["Category-Text"] }}
        </summary>
        <ul>
          <!-- Show children for this specific category -->
          @for ( childItem of getChildrenForCategory(item["Category-Text"]!);
          let i = $index; track childItem["Nav-Item-Text"] || $index ) {
          <li>
            @if (isExternalLink(childItem.Route)) {
            <a
              [routerLinkActive]="'menu-active'"
              [routerLink]="childItem.Route!"
              target="_blank"
              rel="noopener noreferrer"
              class="group"
            >
              {{ childItem["Nav-Item-Text"] }} @if (childItem["Badge text"]) {
              <span
                class="badge badge-xs text-opacity-70 font-mono"
                [ngClass]="getBadgeClass(childItem['Badge text'])"
              >
                {{ childItem["Badge text"] }}
              </span>
              }
            </a>
            } @else {
            <a
              [routerLink]="childItem.Route || '#'"
              routerLinkActive="menu-active"
              class="group"
            >
              {{ childItem["Nav-Item-Text"] }} @if (childItem["Badge text"]) {
              <span
                class="badge badge-xs text-opacity-70 font-mono"
                [ngClass]="getBadgeClass(childItem['Badge text'])"
              >
                {{ childItem["Badge text"] }}
              </span>
              }
            </a>
            }
          </li>
          }
        </ul>
      </details>
    </li>
    }

    <!-- Top-level nav item (with icon, not in category) -->
    @if (isTopLevelItem(item)) {
    <li>
      @if (isExternalLink(item.Route)) {
      <a
        [href]="item.Route!"
        [routerLinkActive]="'menu-active'"
        target="_blank"
        rel="noopener noreferrer"
        class="group"
      >
        @if (isFontAwesomeIcon(item["Category-Icon"])) {
        <i
          class="w-5 h-5 text-base-content contents"
          [ngClass]="item['Category-Icon']"
        ></i>
        } @else if (isFontAwesomeBrandIcon(item["Category-Icon"])) {
        <i
          class="w-5 h-5 text-base-content contents fab"
          [ngClass]="item['Category-Icon']"
        ></i>
        } @else {
        <svg-icon
          [src]="getSvgPath(item['Category-Icon']!)"
          [svgClass]="
                    getSvgIconColorClass(item['Category-Icon-Color-Class']!)
                  "
        ></svg-icon>
        } {{ item["Nav-Item-Text"] }} @if (item["Badge text"]) {
        <span
          class="badge badge-xs text-opacity-70 font-mono"
          [ngClass]="getBadgeClass(item['Badge text'])"
        >
          {{ item["Badge text"] }}
        </span>
        }
      </a>
      } @else {
      <a
        [routerLink]="item.Route || '#'"
        [routerLinkActive]="'menu-active'"
        [routerLinkActiveOptions]="{ exact: true }"
        class="group text-base-content"
      >
        @if (isFontAwesomeIcon(item["Category-Icon"])) {
        <i class="fab fa-spotify"></i>
        } @else {
        <svg-icon
          [src]="getSvgPath(item['Category-Icon']!)"
          [svgClass]="
                    getSvgIconColorClass(item['Category-Icon-Color-Class']!)
                  "
        ></svg-icon>
        } {{ item["Nav-Item-Text"] }} @if (item["Badge text"]) {
        <span
          class="badge badge-xs text-opacity-70 font-mono"
          [ngClass]="getBadgeClass(item['Badge text'])"
        >
          {{ item["Badge text"] }}
        </span>
        }
      </a>
      }
    </li>
    } }

    <!-- Admin Navigation (only for site admins) -->
    @if ((rolesService.roles$ | async)?.site_admin) {
    <li>
      <a routerLink="/admin" routerLinkActive="menu-active" class="group">
        <svg-icon
          [src]="getSvgPath('shield-check')"
          [svgClass]="getSvgIconColorClass('text-error')"
        ></svg-icon>
        Admin
      </a>
    </li>
    }

    <!-- Authentication buttons -->
    <li>
      @if (user$ | async; as user) {
      <!-- User is not logged in - show login button -->
      <button (click)="onLogout()" class="group text-left w-full" type="button">
        <svg-icon
          [src]="getSvgPath('arrow-right-start-on-rectangle')"
          [svgClass]="getSvgIconColorClass('text-red-500')"
        ></svg-icon>
        <div
          class="flex tooltip tooltip-bottom tooltip-arrow tooltip-success"
          [attr.data-tip]="user.email"
        >
          Logout
        </div>
      </button>
      } @else {
      <a class="group text-left w-full" type="button" routerLink="/login">
        <svg-icon
          [src]="getSvgPath('arrow-right-end-on-rectangle')"
          [svgClass]="getSvgIconColorClass('text-green-500')"
        ></svg-icon>
        <div class="flex tooltip tooltip-bottom tooltip-arrow tooltip-success">
          Login
        </div>
      </a>
      }
    </li>
  </ul>
</div>
